
import React from 'react';
import { AlertTriangle } from 'lucide-react';

const SeatsCounter = () => {
  return (
    <div className="text-center mt-3 bg-amber-50 p-3 rounded-lg border-2 border-dashed border-amber-200">
      <p className="text-sm text-amber-700 font-medium flex items-center justify-center">
        <AlertTriangle className="w-5 h-5 mr-2 text-amber-600" /> 
        Only 100 spots available. We're limiting access to protect the quality of this live experience.
      </p>
    </div>
  );
};

export default SeatsCounter;
